module.exports = __webpack_public_path__ + "static/img/technological.0faa6cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/technological.png
// module id = xVT7
// module chunks = 1